// TestimonialPage.jsx
import React, { useState, useEffect } from 'react';
import ReviewCard from '../../components/ReviewCard/Index';
import ReactPaginate from 'react-paginate';
import { fetchAllTestimonials } from '../../Services/testimonialsServices';
import './Testimonials.css';

const TestimonialPage = () => {
  const [reviews, setReviews] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [currentPage, setCurrentPage] = useState(0);
  const ITEMS_PER_PAGE = 8; // Show 8 reviews per page

  useEffect(() => {
    const fetchReviews = async () => {
      try {
        setLoading(true);
        setError(null);
        const testimonials = await fetchAllTestimonials();
        
        const formattedReviews = testimonials?.map(review => ({
          name: review.ReviewerName || review.name,
          time: review.DateCreated || review.time,
          text: review.ReviewText || review.text,
          avatar: review.avatar,
          rating: review.Rating || 0
        })) || [];
        
        setReviews(formattedReviews);
      } catch (err) {
        setError('Failed to load reviews');
        console.error('Error fetching testimonials:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchReviews();
  }, []);

  // Calculate the current page's reviews
  const offset = currentPage * ITEMS_PER_PAGE;
  const currentReviews = reviews.slice(offset, offset + ITEMS_PER_PAGE);
  const pageCount = Math.ceil(reviews.length / ITEMS_PER_PAGE);

  const handlePageChange = ({ selected }) => {
    setCurrentPage(selected);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  if (loading) {
    return (
      <div className="testimonial-page">
        <h1 className="testimonial-heading">Testimonials</h1>
        <hr className="testimonial-divider" />
        <div className="testimonial-loading">Loading reviews...</div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="testimonial-page">
        <h1 className="testimonial-heading">Testimonials</h1>
        <hr className="testimonial-divider" />
        <div className="testimonial-error">{error}</div>
      </div>
    );
  }

  if (!reviews.length) {
    return (
      <div className="testimonial-page">
        <h1 className="testimonial-heading">Testimonials</h1>
        <hr className="testimonial-divider" />
        <div className="no-reviews">No reviews available.</div>
      </div>
    );
  }

  return (
    <div className="testimonial-page">
      <h1 className="testimonial-heading">Testimonials</h1>
      <hr className="testimonial-divider" />
      
      {/* <div className="items-count">
        Showing {Math.min(offset + 1, reviews.length)}-
        {Math.min(offset + ITEMS_PER_PAGE, reviews.length)} of {reviews.length} reviews
      </div> */}

      <div className="testimonial-grid">
        {currentReviews.map((review, index) => (
          <ReviewCard 
            key={`${review.name}-${index}-${currentPage}`} 
            review={review} 
          />
        ))}
      </div>

      <div className="pagination-container">
        <ReactPaginate
          previousLabel={<i className="fa-solid fa-chevron-left"></i>}
          nextLabel={<i className="fa-solid fa-chevron-right"></i>}
          breakLabel="..."
          pageCount={pageCount}
          marginPagesDisplayed={2}
          pageRangeDisplayed={5}
          onPageChange={handlePageChange}
          containerClassName="pagination"
          pageClassName="page-item"
          pageLinkClassName="page-link"
          previousClassName="page-item"
          previousLinkClassName="page-link"
          nextClassName="page-item"
          nextLinkClassName="page-link"
          breakClassName="page-item"
          breakLinkClassName="page-link"
          activeClassName="active"
          forcePage={currentPage}
        />
      </div>
    </div>
  );
};

export default TestimonialPage;